import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Youtube, Music2, Mail, Sparkles } from 'lucide-react';
import { Logo } from './Logo';
const exploreLinks = [{
  name: "Milangela's Story",
  path: '/milangela'
}, {
  name: 'What I Do',
  path: '/services'
}, {
  name: 'Podcasts',
  path: '/podcasts'
}, {
  name: 'Meditation',
  path: '/meditation'
}, {
  name: 'Creative Corner',
  path: '/creative-corner'
}, {
  name: 'Blog',
  path: '/blog'
}, {
  name: 'Testimonies',
  path: '/testimonies'
}, {
  name: 'Contact',
  path: '/contact'
}];
export function Footer() {
  return <footer className="relative bg-charcoal text-cream-100 overflow-hidden" data-id="element-86">
      {/* Soft radial glow accents — very subtle, well inside the panel so no clipped edges */}
      <div aria-hidden="true" className="absolute top-1/4 -left-40 w-[36rem] h-[36rem] rounded-full bg-rose/[0.04] blur-[120px] pointer-events-none" data-id="element-87" />
      <div aria-hidden="true" className="absolute bottom-0 -right-40 w-[36rem] h-[36rem] rounded-full bg-sage/[0.04] blur-[120px] pointer-events-none" data-id="element-88" />

      <div className="relative max-w-5xl mx-auto px-6 pt-20 pb-10 text-center" data-id="element-89">
        {/* Ornament */}
        <div className="flex items-center justify-center gap-3 text-rose mb-6" data-id="element-90">
          <span className="block h-px w-12 bg-cream-100/20" data-id="element-91" />
          <Sparkles size={16} strokeWidth={1.25} data-id="element-92" />
          <span className="block h-px w-12 bg-cream-100/20" data-id="element-93" />
        </div>

        {/* Closing thought */}
        <p className="font-serif italic text-cream text-2xl md:text-3xl leading-relaxed max-w-2xl mx-auto mb-10" data-id="element-94">
          May you walk gently, listen deeply, and return to your own quiet
          center.
        </p>

        {/* Logo + name */}
        <Link to="/" className="inline-block mb-3" data-id="element-95">
          <Logo variant="white" className="h-14 w-auto mx-auto" data-id="element-96" />
        </Link>
        <p className="font-serif text-cream text-lg" data-id="element-97">Milangela's Soul Garden</p>
        <p className="text-cream-100/70 text-sm tracking-widest uppercase mt-1 mb-10" data-id="element-98">
          Branka Androjna
        </p>

        {/* Nav */}
        <nav className="flex flex-wrap items-center justify-center gap-x-7 gap-y-3 mb-10" data-id="element-99">
          {exploreLinks.map(l => <Link key={l.path} to={l.path} className="text-sm text-cream-100/85 hover:text-cream transition-colors tracking-wide" data-id="element-100">
              {l.name}
            </Link>)}
        </nav>

        {/* Email */}
        <a href="mailto:branka@milangelassoulgarden.com" className="inline-flex items-center gap-2 text-rose hover:text-rose-100 transition-colors text-sm mb-6 group" data-id="element-101">
          <span className="w-7 h-7 rounded-full border border-rose/40 flex items-center justify-center group-hover:border-rose transition-colors" data-id="element-102">
            <Mail size={13} strokeWidth={1.5} data-id="element-103" />
          </span>
          <span className="font-serif italic text-base" data-id="element-104">
            branka@milangelassoulgarden.com
          </span>
        </a>

        {/* Socials */}
        <div className="flex items-center justify-center gap-5 mb-12" data-id="element-105">
          <a href="#" aria-label="Facebook" className="text-cream-100/80 hover:text-cream hover:-translate-y-0.5 transition-all" data-id="element-106">
            <Facebook size={20} strokeWidth={1.5} data-id="element-107" />
          </a>
          <a href="#" aria-label="Instagram" className="text-cream-100/80 hover:text-cream hover:-translate-y-0.5 transition-all" data-id="element-108">
            <Instagram size={20} strokeWidth={1.5} data-id="element-109" />
          </a>
          <a href="#" aria-label="YouTube" className="text-cream-100/80 hover:text-cream hover:-translate-y-0.5 transition-all" data-id="element-110">
            <Youtube size={20} strokeWidth={1.5} data-id="element-111" />
          </a>
          <a href="#" aria-label="Spotify" className="text-cream-100/80 hover:text-cream hover:-translate-y-0.5 transition-all" data-id="element-112">
            <Music2 size={20} strokeWidth={1.5} data-id="element-113" />
          </a>
        </div>

        {/* Bottom strip */}
        <div className="border-t border-cream-100/20 pt-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-cream-100/70" data-id="element-114">
          <p data-id="element-115">
            © {new Date().getFullYear()} Milangela's Soul Garden — made with
            care.
          </p>
          <div className="flex items-center gap-5" data-id="element-116">
            <Link to="#" className="hover:text-cream-100 transition-colors" data-id="element-117">
              Privacy & Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}